// Reveal — voegt `is-visible` toe zodra een [data-reveal] in beeld komt.

export function initReveal() {
    const els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;

    if (typeof IntersectionObserver === "undefined") {
        els.forEach((el) => el.classList.add("is-visible"));
        return;
    }

    const io = new IntersectionObserver(
        (entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    e.target.classList.add("is-visible");
                    io.unobserve(e.target);
                }
            });
        },
        { threshold: 0.05 },
    );

    els.forEach((el) => {
        io.observe(el);
        // Safety net: reveal anyway after 1.4s in case observer never fires.
        setTimeout(() => el.classList.add("is-visible"), 1400);
    });
}
